import styled from 'styled-components';
import {
  FlexColumn,
  FormControls,
  TextFieldReadOnly,
} from '@elementary/common-ui/components';
import { statusLabelMap } from '@elementary/common-ui/utils/common';
import { Severity } from 'shared/types';

const TextFieldReadOnlyStyed = styled(TextFieldReadOnly)`
  min-width: 50px;
  justify-content: center;
`;

type Props = {
  severity: Severity;
  warnIf?: string;
  errorIf?: string;
  showTitle?: boolean;
};

const SeverityRenderer = ({
  severity,
  warnIf,
  errorIf,
  showTitle = true,
}: Props) => (
  <FlexColumn sx={{ gap: 2 }}>
    {!errorIf && !warnIf && (
      <FormControls.Row>
        {showTitle && <FormControls.FormText>Severity:</FormControls.FormText>}
        <TextFieldReadOnlyStyed
          value={statusLabelMap[severity.toLowerCase()]}
        />
      </FormControls.Row>
    )}
    {errorIf && (
      <FormControls.Row>
        <FormControls.FormText>
          Return error if the number of failures is
        </FormControls.FormText>
        <TextFieldReadOnlyStyed value={errorIf} />
      </FormControls.Row>
    )}
    {warnIf && (
      <FormControls.Row>
        <FormControls.FormText>
          Return warning if the number of failures is
        </FormControls.FormText>
        <TextFieldReadOnlyStyed value={warnIf} />
      </FormControls.Row>
    )}
  </FlexColumn>
);

export default SeverityRenderer;
